import { Link } from "react-router-dom";
import BarmaidLogo from "./BarmaidLogo";
import LangToggle from "./LangToggle";
import ThemeToggle from "./ThemeToggle";
import { useT } from "../i18n";
import { appUrl } from "../lib/appUrl";
import { btnPrimary } from "../lib/ui";

const ANCHOR_LINKS = [
  { href: "/#how-it-works", key: "navHowItWorks" as const },
  { href: "/#for-venues", key: "navForVenues" as const },
  { href: "/#why-barmaid", key: "navWhyBarmaid" as const },
];

const ROUTE_LINKS = [{ to: "/contact", key: "navContact" as const }];

export default function Header() {
  const translate = useT();

  return (
    <header className="sticky top-0 z-50 glass border-b border-[var(--border-subtle)]">
      <div className="mx-auto flex max-w-6xl items-center justify-between gap-4 px-4 py-3 sm:px-6">
        <Link to="/" className="shrink-0" aria-label="Barmaid home">
          <BarmaidLogo size={32} />
        </Link>

        <nav className="hidden items-center gap-6 md:flex" aria-label="Main">
          {ANCHOR_LINKS.map((link) => (
            <a
              key={link.key}
              href={link.href}
              className="text-sm font-medium text-muted-foreground transition hover:text-foreground"
            >
              {translate(link.key)}
            </a>
          ))}
          {ROUTE_LINKS.map((link) => (
            <Link
              key={link.key}
              to={link.to}
              className="text-sm font-medium text-muted-foreground transition hover:text-foreground"
            >
              {translate(link.key)}
            </Link>
          ))}
        </nav>

        <div className="flex items-center gap-2 sm:gap-3">
          <LangToggle compact />
          <ThemeToggle compact />
          <a href={appUrl("/admin/register")} className={`${btnPrimary} hidden sm:inline-flex`}>
            {translate("navGetStarted")}
          </a>
        </div>
      </div>
    </header>
  );
}
